import type { ReactNode } from 'react';

import {
  MAX_DAPP_NAME_LENGTH,
  MAX_SUBTITLE_LENGTH,
} from '../../../constants/form';
import * as Form from '../../Form';
import { CharacterCountHint } from '../../shared/CharacterCountHint';
import type { DappFormInputChangeEvent } from '../types';

interface BasicDetailsSectionBaseProps {
  dappName: string;
  subtitle: string;
  description: string;
  subtitleHintText: string;
  onInputChange?: (event: DappFormInputChangeEvent) => void;
  packageNameField: ReactNode;
  uploadFields: ReactNode;
  previewUploadsField: ReactNode;
}

export function BasicDetailsSectionBase({
  dappName,
  subtitle,
  description,
  subtitleHintText,
  onInputChange,
  packageNameField,
  uploadFields,
  previewUploadsField,
}: BasicDetailsSectionBaseProps) {
  return (
    <section className="self-stretch flex flex-col gap-6">
      <div className="self-stretch flex flex-col gap-1">
        <Form.Input
          label="dApp Name"
          name="dappName"
          defaultValue={dappName}
          onChange={onInputChange}
          maxLength={MAX_DAPP_NAME_LENGTH}
          required
        />
        <CharacterCountHint
          text={`Maximum ${MAX_DAPP_NAME_LENGTH} characters`}
        />
      </div>

      {packageNameField}

      <div className="self-stretch flex flex-col gap-1">
        <Form.Input
          label="Subtitle"
          explanation="This appears beneath your dApp name in lists and on the detail page."
          name="subtitle"
          defaultValue={subtitle}
          onChange={onInputChange}
          maxLength={MAX_SUBTITLE_LENGTH}
        />
        <CharacterCountHint text={subtitleHintText} />
      </div>

      <div className="self-stretch flex flex-col gap-1">
        <Form.Textarea
          label="Description"
          explanation="In a short paragraph, describe your dApp."
          id="description"
          name="description"
          defaultValue={description}
          onChange={onInputChange}
          rows={4}
          required
        />
      </div>

      {uploadFields}

      {previewUploadsField}
    </section>
  );
}
